import { ScheduleEmploymentPostData } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/Employment/useEmployment';
import { EmpPositionPostData } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmployment/data';
import { EmploymentDetailPostData } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/components/ScheduleEmploymentDetail/data';
import { fetchFromOldApi } from '~/services/Http';

export { getContracts, updateContracts } from './contracts';
export { mapDefaultData } from './mapDefaultData';

export type SchedulePostData = {
  empPosition?: EmpPositionPostData;
  employment?: ScheduleEmploymentPostData;
  employmentDetails?: EmploymentDetailPostData;
};

export const scheduleChanges = async (
  empId: number,
  data: SchedulePostData,
  fEmpEmplId?: number,
) => {
  const api = fEmpEmplId
    ? `/json/employee/${empId}/fullemployment/${fEmpEmplId}`
    : `/json/employee/${empId}/scheduledemployment`;
  return await fetchFromOldApi(api, {
    method: fEmpEmplId ? 'PUT' : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
    .then((r) => r.text())
    .catch((e) => {
      const errorResult = e.text();
      return errorResult.then((r: string) => {
        try {
          const rObject = JSON.parse(r);
          if (rObject?.error?.detail?.includes('taxNumber')) {
            return { error: 'laDupTaxNum' };
          }
          return { error: 'laGeneralError' };
        } catch (e) {
          return { error: 'laGeneralError' };
        }
      });
    });
};

export const deleteEmployment = async (empId: number, fEmpEmplId: number) => {
  return await fetchFromOldApi(
    `/json/employee/${empId}/scheduledemployment/${fEmpEmplId}`,
    {
      method: 'DELETE',
    },
  )
    .then((r) => r.text())
    .catch((e) => {
      return { error: 'laGeneralError' };
    });
};

export const contractNumberChange = async (
  contractNumber: string,
  empId: number,
) => {
  await fetchFromOldApi(`/json/employee/${empId}/contractNumber`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(contractNumber),
  });
};

export const businessUnitChange = async (
  businessUnits: { treeId: number; unitId: number }[],
  empId: number,
) => {
  fetchFromOldApi(`/json/employee/${empId}/full`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fEmpBusinessUnits: businessUnits }),
  });
};

export const employeeNumberChange = async (
  employeeNumber: string,
  empId: number,
) =>
  await fetchFromOldApi(`/json/employee/${empId}/number`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(employeeNumber),
  })
    .then((r) => r.text())
    .catch((e) => {
      const errorResult = e.text();
      return errorResult.then((r: string) => {
        try {
          const rObject = JSON.parse(r);
          if (rObject?.error?.detail?.includes('employee_number')) {
            return { error: 'laEmpDupNumber' };
          }
          return { error: 'laGeneralError' };
        } catch (e) {
          return { error: 'laGeneralError' };
        }
      });
    });
